// extracted by mini-css-extract-plugin
module.exports = {"rssStyle":"RssDirective_rssStyle__FIjJt","muted":"RssDirective_muted__lwbjI"};